function cov_t936jgv1o() {
  var path = "/app/src/components/default-promo-widget/components/default-snippet/index.ts";
  var hash = "e09be57c5fd05a297c465b307cb3853e1cdf09b2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/default-snippet/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e09be57c5fd05a297c465b307cb3853e1cdf09b2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_t936jgv1o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_t936jgv1o();
export { DefaultSnippet } from './default-snippet';